<template>

  <div>
    <AvailableList
      :loading="connectionsLoading"
      :connections="connections"
      title="Available for Processing Now"
      :hide-connect="true"
    ></AvailableList>
  </div>

</template>

<script>

import axios from "@/axios";
import AvailableList from "@/components/Processing/AvailableList.vue";

export default {
  components: {AvailableList},
  data() {
    return {
      connections: [],
      connectionsLoading: false,
    }
  },
  methods: {
    getConnections() {
      this.connectionsLoading = true;
      axios('connections/connected/list?with-availability=1').then(res => {
        this.connections = res.data || [];
        if (this.connections.length < 5) {
          this.loadSuggestions(this.connections.length);
        }
      }).finally(() => {
        this.connectionsLoading = false;
      });
    },

    loadSuggestions(currentCount) {
      const needed = 5 - currentCount;
      axios('connections/available').then(res => {
        const available = res.data || [];
        const suggestions = available.slice(0, needed).map(m => ({
          ...m,
          user_id_1: m.id,
          connection_status: m.connection_status || 'none',
        }));
        if (suggestions.length) {
          this.connections = [...this.connections, ...suggestions]
              .sort((a, b) => b.is_available - a.is_available);
        }
      }).catch(() => {});
    },
  },
  created() {
    this.getConnections();
  },
}
</script>
